import { type Routes } from '@angular/router';
import { authGuard } from '@core/auth/guards/auth.guard';

import { SHELL_DEV_ROUTES } from './shell-dev.routes';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'access',
    loadChildren: () => import('./features/access/access.routes').then((m) => m.ACCESS_ROUTES),
  },
  {
    path: '',
    loadComponent: () =>
      import('./core/layout/shell-layout.component').then((m) => m.ShellLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
      },
      ...SHELL_DEV_ROUTES,
      {
        path: 'customs-declaration',
        loadChildren: () =>
          import('./features/customs-declaration/customs-declaration.routes').then(
            (m) => m.CUSTOMS_DECLARATION_ROUTES,
          ),
      },
      {
        path: 'temporary-storage-document',
        loadChildren: () =>
          import('./features/temporary-storage-document/temporary-storage-document.routes').then(
            (m) => m.TEMPORARY_STORAGE_DOCUMENT_ROUTES,
          ),
      },
    ],
  },
  {
    path: 'not-found',
    loadChildren: () =>
      import('./features/fallback/fallback.routes').then((m) => m.FALLBACK_ROUTES),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
